const getCommit = () =>
	process.env.REACT_APP_COMMIT_SHA
		? process.env.REACT_APP_COMMIT_SHA.substring(0, 8)
		: 'unknown';

export default getCommit;
